import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AdminTableComponent from 'routes/Admin/components/CommonComponents/AdminTableComponent'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { withStyles } from '@material-ui/core/styles'
import {
  MODAL_ADMIN_EDIT_CUSTOMER,
  MODAL_ADMIN_CREATE_CUSTOMER
} from 'redux/modules/modals'
const columnDataAll = [
  {
    id: 'customers_last_name',
    numeric: false,
    disablePadding: true,
    label: 'Nom'
  },
  {
    id: 'customers_first_name',
    numeric: false,
    disablePadding: true,
    label: 'Prénom'
  },
  {
    id: 'customers_email',
    numeric: false,
    disablePadding: true,
    label: 'Email'
  },
  {
    id: 'customers_phone_number',
    numeric: false,
    disablePadding: true,
    label: 'Téléphone'
  },
  {
    id: 'isMember',
    bool: true,
    disablePadding: true,
    label: 'Membre',
    transform: value => value
  }
]
const columnDataMember = [
  {
    id: 'customers_last_name',
    numeric: false,
    disablePadding: true,
    label: 'Nom'
  },
  {
    id: 'customers_first_name',
    numeric: false,
    disablePadding: true,
    label: 'Prénom'
  },
  {
    id: 'customers_email',
    numeric: false,
    disablePadding: true,
    label: 'Email'
  },
  {
    id: 'customers_phone_number',
    numeric: false,
    disablePadding: true,
    label: 'Téléphone'
  },
  {
    id: 'isMember',
    bool: true,
    disablePadding: true,
    label: 'Membre',
    transform: value => value
  },
  {
    id: 'expirationDate',
    expiration: true,
    disablePadding: true,
    label: `Date d'expiration`
  }
]
const styles = theme => ({
  rootTabs: {
    flexGrow: 1,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    height: 51
  },
  rootTab: {
    height: 51,
    maxWidth: 'none'
  }
})
export default withStyles(styles)(
  class AdminCustomersComponent extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
      customers: PropTypes.array.isRequired,
      showModal: PropTypes.func.isRequired
    }
    state = {
      tabValue: 0,
      currentCategory: void 0
    }
    handleCreateProductClick = () => {
      this.props.showModal(MODAL_ADMIN_CREATE_CUSTOMER)
    }
    handleEditProductClick = customer => {
      this.props.showModal(MODAL_ADMIN_EDIT_CUSTOMER, customer)
    }

    handleDeleteClick = category => {
      // this.props.showModal(MODAL_ADMIN_DELETE_PRODUCT, category)
    }
    handleChange = (event, value) => {
      this.setState({ tabValue: value })
    }
    render() {
      const { classes, customers } = this.props
      const { tabValue } = this.state
      let currentCustomers = []
      switch (tabValue) {
        case 0:
          currentCustomers = customers
          break
        case 1:
          currentCustomers = customers.filter(c => c.isMember)
          break
        default:
      }
      return (
        <section className="pageAdmin">
          <Tabs
            className={classes.rootTabs}
            value={tabValue}
            onChange={this.handleChange}
            fullWidth
            centered
            scrollButtons="off"
            indicatorColor="secondary">
            <Tab className={classes.rootTab} label="Tous les clients" />
            <Tab className={classes.rootTab} label="Membres" />
          </Tabs>
          <AdminTableComponent
            title={tabValue === 0 ? 'Clients' : 'Membres'}
            list={currentCustomers}
            orderBy={'id'}
            columnData={tabValue === 0 ? columnDataAll : columnDataMember}
            addButtonAction={this.handleCreateProductClick}
            editButtonAction={this.handleEditProductClick}
          />
        </section>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Admin/Customers/components/AdminCustomersComponent.js